import React from 'react'
import { Container, Grid, Box } from '@mui/material'
import ImprovedProductCard from './ImprovedProductCard'
import { useShoppingCart } from '../../context/ShoppingCartContext'
import { isHiddenWhenOut } from '../../data/stockOutages'

// CONTROLLABLE SPACING - Change this value to adjust gap between banner and products
const BANNER_TO_PRODUCTS_SPACING = '8px'

export default function Products() {
    const { data, outages, market } = useShoppingCart()

    const renderProducts = data
        .slice() // don't sort the shared array in place
        .sort((p1, p2) => (p1.displayOrder < p2.displayOrder ? -1 : 1))
        // onHandQty <= 0 = permanently unlisted (placeholders, discontinued).
        .filter(({ onHandQty }) => onHandQty > 0)
        // Temporary outages stay visible with an "out of stock" state by
        // default; an entry with hide:true is removed from the grid.
        .filter(
            ({ productIDNum }) =>
                !isHiddenWhenOut(outages, productIDNum, market),
        )
        .map((product) => (
            <Grid item key={product.productNum} xs={12} sm={6} md={4}>
                <ImprovedProductCard product={product} />
            </Grid>
        ))

    return (
        <Box
            sx={{
                marginTop: BANNER_TO_PRODUCTS_SPACING, // Controllable spacing from banner
            }}
        >
            <Container>
                <Grid
                    container
                    spacing={{ xs: 2, md: 3 }}
                    justifyContent="center"
                    sx={{
                        paddingBottom: '20px',
                    }}
                >
                    {renderProducts}
                </Grid>
            </Container>
        </Box>
    )
}
